<template>
  <b-button
    size="sm"
    variant="link"
    class="p-0 ml-1"
    :disabled="busy"
    :title="copied ? 'Copied!' : 'Copy shortened link'"
    @click.stop="copyShortUrl"
  >
    <i v-if="busy" class="fa fa-spinner fa-spin" style="font-size: 12px;" aria-hidden="true"></i>
    <i v-else-if="copied" class="fa fa-check" style="font-size: 12px;" aria-hidden="true"></i>
    <i v-else class="fa fa-copy" style="font-size: 12px;" aria-hidden="true"></i>
  </b-button>
</template>

<script>
import { shorten_url_for_vsm } from '@/networking/apis'
import { resolveStandaloneUrl, copyToClipboard } from '@/helpers/vsm_standalone_url'

export default {
  name: 'VsmStandaloneUrlCopyButton',
  props: {
    href: { type: String, required: true },
    tenantId: { type: String, required: true },
  },
  data() {
    return {
      busy: false,
      copied: false,
      copiedTimer: null,
    }
  },
  beforeDestroy() {
    if (this.copiedTimer) clearTimeout(this.copiedTimer)
  },
  methods: {
    async copyShortUrl() {
      if (this.busy || !this.href || !this.tenantId) return
      this.busy = true
      this.copied = false
      try {
        const longUrl = resolveStandaloneUrl(this.href)
        const resp = await shorten_url_for_vsm(longUrl, this.tenantId)
        const shortUrl = resp.value && resp.value.data && resp.value.data.short_url
        if (!shortUrl) throw new Error('no short url returned')
        await copyToClipboard(shortUrl)
        this.copied = true
        if (this.copiedTimer) clearTimeout(this.copiedTimer)
        this.copiedTimer = setTimeout(() => { this.copied = false }, 2000)
      } catch (e) {
        console.error('Failed to copy shortened VSM URL', e)
        alert('Failed to copy shortened link')
      } finally {
        this.busy = false
      }
    },
  },
}
</script>
